import { Store } from 'pullstate';
import { PuzzleStoreBase, PuzzleStoreBaseDefaults } from '../../../utils/types';

export type VaryCloveStoreType = PuzzleStoreBase & {
  cursorLocation: number[]; // a tuple of the form [wordIndex, letterIndex]
  guessWords: string[][];
  prompt: string;
  cluePhrase: string;
  numAlteredLetters: number;
  solution: string;
  solutionAsCharArrays: string[][];
};

export const VaryCloveStore = new Store<VaryCloveStoreType>({
  ...PuzzleStoreBaseDefaults,
  cursorLocation: [0, 0],
  guessWords: [],
  prompt: '',
  cluePhrase: '',
  numAlteredLetters: 0,
  solution: '',
  solutionAsCharArrays: [],
});